import React from 'react';

import { DetailPageLayout } from 'src/components/common';
import { EmployerSettingsForm } from 'src/components/employer';

export const EmployerSettingsPageCVStaff: React.FC = () => {
  return (
    <DetailPageLayout titleContent="Settings">
      <EmployerSettingsForm />
    </DetailPageLayout>
  );
};
